import Highlighter from 'react-highlight-words';

export default Highlighter;
